import { createNlsMiddleware } from 'lcc-state';

export const nls = createNlsMiddleware('glossary');
